<template>
  <v-container fluid>
    <div v-if="hospital">
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.name"
      :labelTitle="$t('dash.info.form-name')"
      required
      :placeholder="$t('dash.info.form-name')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.streetName"
      :labelTitle="$t('dash.info.form-street')"
      required
      :placeholder="$t('dash.info.form-street')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.streetNumber"
      :labelTitle="$t('dash.info.form-number')"
      required
      :placeholder="$t('dash.info.form-number')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.postalCode"
      :labelTitle="$t('dash.info.form-postal')"
      required
      :placeholder="$t('dash.info.form-postal')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.city"
      :labelTitle="$t('dash.info.form-city')"
      required
      :placeholder="$t('dash.info.form-city')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.addressLineExtra"
      :labelTitle="$t('dash.info.form-extra')"
      :placeholder="$t('dash.info.form-extra')"
      margin="25px auto"
    />

    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.link"
      :labelTitle="$t('dash.info.form-site')"
      :placeholder="$t('dash.info.form-site')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.otherLocationInfo"
      :labelTitle="$t('dash.info.form-extra-location')"
      :placeholder="$t('dash.info.form-extra-location')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.email"
      required
      :labelTitle="$t('dash.info.form-email')"
      :placeholder="$t('dash.info.form-email')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.phonePrimary"
      :labelTitle="$t('dash.info.form-phone-1')"
      :placeholder="$t('dash.info.form-phone-1')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.phoneSecondary"
      :labelTitle="$t('dash.info.form-phone-alternative-1')"
      :placeholder="$t('dash.info.form-phone-alternative-1')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.phoneOther"
      :labelTitle="$t('dash.info.form-phone-alternative-2')"
      :placeholder="$t('dash.info.form-phone-alternative-2')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.otherContactInfo"
      :labelTitle="$t('dash.info.form-extra-contact')"
      :placeholder="$t('dash.info.form-extra-contact')"
      margin="25px auto"
    />
    <InputField
      :disabled="this.$store.getters.user.role === 'n'"
      v-model="hospital.defaultLanguage"
      :labelTitle="$t('dash.info.form-default-language')"
      :placeholder="$t('dash.info.form-default-language')"
      margin="25px auto"
    />

    <div class="container">
      <div class="row">
        <div class="col-sm">
          <div class="consent-checkbox">
            <label for="mediligoConsent" class="checkbox-container">
              {{ $t("dash.info.form-use-curae-consent") }} <small
              v-if="this.$store.getters.user.role === 'n' || this.$store.getters.environment === 'production'"
              class="ml-1"> | {{ $t("dash.info.not-editable") }}</small>
              <input
                style="background-color: #e05484; accent-color: #e05484"
                :disabled="this.$store.getters.user.role === 'n' || this.$store.getters.environment === 'production'"
                type="checkbox"
                id="mediligoConsent"
                v-model="hospital.useCuraeConsent"
              />
              <span class="checkmark" style="border-color: #e05484"></span>
            </label>
          </div>

          <div class="consent-checkbox" v-if="!epdIntegrationEnabled">
            <label for="multiAccount" class="checkbox-container">
              {{ $t("dash.info.form-strict-accounts") }} <small
              v-if="this.$store.getters.user.role === 'n' || this.$store.getters.environment === 'production'"
              class="ml-1"> | {{ $t("dash.info.not-editable") }}</small>
              <input
                style="background-color: #e05484; accent-color: #e05484"
                :disabled="this.$store.getters.user.role === 'n' || this.$store.getters.environment === 'production'"
                type="checkbox"
                id="multiAccount"
                v-model="strictAccounts"
              />
              <span class="checkmark" style="border-color: #e05484"></span>
            </label>
          </div>

          <div class="consent-checkbox">
            <label for="postNotificationsDailyMail" class="checkbox-container">
              {{ $t("dash.info.form-notifications-daily-posts-via-mail-dash") }}
              <input
                style="background-color: #e05484; accent-color: #e05484"
                :disabled="this.$store.getters.user.role === 'n'"
                type="checkbox"
                id="postNotificationsDailyMail"
                v-model="hospital.notificationSettings.postsViaMail"
              />
              <span class="checkmark" style="border-color: #e05484"></span>
            </label>
          </div>

          <div class="consent-checkbox">
            <label for="visitNotificationsViaMail" class="checkbox-container">
              {{ $t("dash.info.form-notifications-visit-updates-via-mail-dash") }}
              <input
                style="background-color: #e05484; accent-color: #e05484"
                :disabled="this.$store.getters.user.role === 'n'"
                type="checkbox"
                id="visitNotificationsViaMail"
                v-model="hospital.notificationSettings.visitUpdatesViaMail"
              />
              <span class="checkmark" style="border-color: #e05484"></span>
            </label>
          </div>
          <div class="consent-checkbox">
            <label for="inviteByParentAllowed" class="checkbox-container">
              {{ $t("dash.info.form-parent-can-invite") }} <small class="ml-1"> | {{
                $t("dash.info.not-editable")}} </small>
              <input
                  style="background-color: #e05484; accent-color: #e05484"
                  type="checkbox"
                  disabled
                  id="inviteByParentAllowed"
                  v-model="inviteByParentAllowed"
              />
              <span class="checkmark" style="border-color: #e05484"></span>
            </label>
          </div>
        </div>

        <div class="col-sm">
          <div class="consent-checkbox">
            <label for="mediligoConsent" class="checkbox-container">
              {{ $t("dash.info.form-epd-integration-enabled") }} <small class="ml-1"> | {{
                $t("dash.info.not-editable")
              }}</small>
              <input
                style="background-color: #e05484; accent-color: #e05484"
                disabled
                type="checkbox"
                id="mediligoConsent"
                v-model="epdIntegrationEnabled"
              />
              <span class="checkmark" style="border-color: #e05484"></span>
            </label>
          </div>
            <div class="consent-checkbox">
              <label for="hl7Enabled" class="checkbox-container">
                {{ $t("dash.info.form-hl7-integration-enabled") }} <small class="ml-1"> | {{
                  $t("dash.info.not-editable")
                }}</small>
                <input
                  style="background-color: #e05484; accent-color: #e05484"
                  disabled
                  type="checkbox"
                  id="hl7Enabled"
                  v-model="hl7IntegrationEnabled"
                />
                <span class="checkmark" style="border-color: #e05484"></span>
              </label>
            </div>
<!--          <div class="consent-checkbox">-->
<!--            <label for="multiAccount" class="checkbox-container">-->
<!--              {{ $t("dash.info.form-ad-integration-enabled") }} <small class="ml-1"> | {{-->
<!--                $t("dash.info.not-editable")-->
<!--              }}</small>-->
<!--              <input-->
<!--                style="background-color: #e05484; accent-color: #e05484"-->
<!--                disabled-->
<!--                type="checkbox"-->
<!--                id="multiAccount"-->
<!--                v-model="adIntegrationEnabled"-->
<!--              />-->
<!--              <span class="checkmark" style="border-color: #e05484"></span>-->
<!--            </label>-->
<!--          </div>-->

        </div>
      </div>
    </div>

    <p v-if="!requiredFilledIn" style="color: red;">{{ $t('dash.info.required-not-filled') }}</p>

    <LoadingButton v-if="loading"/>
    <Button v-if="this.$store.getters.user.role !== 'n' && !loading" @click.native="save"
            :title="$t('dash.info.action-save')"/>
    </div>
  </v-container>
</template>

<script>
import {neoparentHospital} from "@/api";

export default {
  name: "neoparent-hospital-info",
  data() {
    return {
      strictAccounts: true,
      hospital: {},
      epdIntegrationEnabled: false,
      hl7IntegrationEnabled: false,
      emailInviteEnabled: true,
      codeInviteEnabled: false,
      adIntegrationEnabled: false,
      inviteByParentAllowed: true,
      loading: false,
      error: null
    };
  },
  async mounted() {
    const tmp = await neoparentHospital.getHospitalInfo();
    this.hospital = tmp.data.hospital;
    if (this.hospital.inviteMethods) {
      const methods = this.hospital.inviteMethods.split(",")
      console.log('methods', methods)
      this.codeInviteEnabled = methods.includes('code')
      this.emailInviteEnabled = methods.includes('email')
    } else {
      this.emailInviteEnabled = true;
    }
    this.strictAccounts = !this.hospital.multiAccountSupport

    if (this.hospital.epdSettings) {
      this.epdIntegrationEnabled = this.hospital.epdSettings.epdEnabled
      this.hl7IntegrationEnabled = this.hospital.hl7Enabled
      this.adIntegrationEnabled = this.hospital.epdSettings.adIntegrationEnabled
    }
    this.inviteByParentAllowed = !this.hospital.inviteByParentBlocked
  },
  computed: {
    requiredFilledIn() {
      if (!this.hospital.name || this.hospital.name === 0) return false;
      if (!this.hospital.streetName || this.hospital.streetName === 0) return false;
      if (!this.hospital.streetNumber || this.hospital.streetNumber === 0) return false;
      if (!this.hospital.postalCode || this.hospital.postalCode === 0) return false;
      if (!this.hospital.city || this.hospital.city.length === 0) return false;
      if (!this.hospital.email || this.hospital.email.length === 0) return false;

      return true
    }
  },
  methods: {
    save() {
      const methods = [];
      if (this.emailInviteEnabled) methods.push('email')
      if (this.codeInviteEnabled) methods.push('code')

      const data = {
        id: this.hospital.id,
        name: this.hospital.name,
        streetName: this.hospital.streetName,
        streetNumber: this.hospital.streetNumber,
        postalCode: this.hospital.postalCode,
        city: this.hospital.city,
        addressLineExtra: this.hospital.addressLineExtra,
        link: this.hospital.link,
        otherLocationInfo: this.hospital.otherLocationInfo,
        email: this.hospital.email,
        phonePrimary: this.hospital.phonePrimary,
        phoneSecondary: this.hospital.phoneSecondary,
        phoneOther: this.hospital.phoneOther,
        otherContactInfo: this.hospital.otherContactInfo,
        defaultLanguage: this.hospital.defaultLanguage,
        useCuraeConsent: this.hospital.useCuraeConsent,
        multiAccountSupport: !this.strictAccounts,
        inviteMethods: methods.join(","),
        notificationSettings: this.hospital.notificationSettings
      };

      if (this.requiredFilledIn) {
        this.loading = true;

        neoparentHospital
          .editHospitalInfo(data)
          .then(result => {
            this.consoleLog(result);
            this.loading = false;
            this.redirect("/dashboard");
          })
          .catch(err => {
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
            this.consoleLog(err);
            this.loading = false;
          });
      }
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  padding-bottom: 50px;
}
</style>
